import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getUsedBy } from '../../services/discover';
import { isGlobal } from '../../utils/collectionKinds';
import { normalizeId } from '../../utils/ids';
import { packagePath } from '../../utils/packageAddress';

/**
 * "Used by" on a global collection's About (KPR-387): the Discover packages
 * whose cards point into it, each a link to its page. Nothing at all when no
 * package does, and until KPR-384 lets a bundle point at a published
 * collection that is every collection. It sits in the About list beside
 * Source and License, so it takes the same `Fact` renderer.
 */
export default function UsedBy({ collection, Fact }) {
	const global = Boolean(collection) && isGlobal(collection);
	const id = global ? normalizeId(collection._id) : null;
	const [rows, setRows] = useState([]);
	useEffect(() => {
		let live = true;
		setRows([]);
		if (id) getUsedBy(id).then(list => { if (live) setRows(list); }).catch(() => {});
		return () => { live = false; };
	}, [id]);
	if (!rows.length) return null;
	return (
		<Fact label="Used by" testId="used-by">
			<ul className="used-by">
				{rows.map(row => <li key={row.key}><Link to={packagePath(row.key)}>{row.name}</Link></li>)}
			</ul>
		</Fact>
	);
}
